export default class CreateOrganizationAdminRequest {
  public firstName: string = ''
  public lastName: string = ''
  public emailAddress: string = ''
  public password: string = ''
  public description: string = ''
  public roleIds: Array<string> = []
}
